import { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';

/**
 * Диплинк-действие из query-параметра: если `?<param>=<value>` присутствует, один раз выполняет
 * `action` и убирает параметр из URL (`replace`, без записи в историю). Используется для ссылок,
 * ведущих не «на страницу», а сразу к действию: `?createNew=true`, `?addContact=true` и т.п.
 *
 * action держим в ref — эффект зависит только от searchParams, поэтому не перезапускается из-за
 * пересоздания колбэка; после очистки параметра условие больше не выполняется.
 */
export function useDeepLinkAction(param: string, action: () => void, value = 'true'): void {
  const [searchParams, setSearchParams] = useSearchParams();
  const actionRef = useRef(action);
  actionRef.current = action;

  useEffect(() => {
    if (searchParams.get(param) !== value) {
      return;
    }
    actionRef.current();
    const next = new URLSearchParams(searchParams);
    next.delete(param);
    setSearchParams(next, { replace: true, preventScrollReset: true });
  }, [param, value, searchParams, setSearchParams]);
}
